import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { AuthShell, Field, inputCls, primaryBtn } from "@/components/AuthShell";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { setSent((await http.post("/auth/forgot-password", { email })).data.message); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="Forgot your password?" subtitle="No worries. We'll email you a link to choose a new one.">
      {sent ? <p className="rounded-2xl bg-[#EEF3EF] text-[#2C4A3E] text-sm p-4" data-testid="forgot-sent">{sent}</p> : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <Field label="Email"><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="forgot-email-input" /></Field>
          <button disabled={busy} className={primaryBtn} data-testid="forgot-submit-btn">{busy ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
      <p className="mt-6 text-sm text-stone-500">Kids who sign in with pictures: ask a parent to reset your pictures. <Link to="/login" className="text-[#C87D53]" data-testid="forgot-back-login">Back to log in</Link></p>
    </AuthShell>
  );
}

export function ResetPassword() {
  const [q] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("The two passwords don't match");
    setBusy(true);
    try { await http.post("/auth/reset-password", { token: q.get("token") || "", password: pw }); toast.success("Password changed. Please log in."); nav("/login"); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="Choose a new password" subtitle="Use at least 8 characters.">
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <Field label="New password"><input type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} className={inputCls} data-testid="reset-password-input" /></Field>
        <Field label="Type it again"><input type="password" required minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} className={inputCls} data-testid="reset-password-confirm" /></Field>
        <button disabled={busy} className={primaryBtn} data-testid="reset-submit-btn">{busy ? "Saving…" : "Save new password"}</button>
      </form>
      <p className="mt-6 text-sm text-stone-500">Link expired? <Link to="/forgot-password" className="text-[#C87D53]" data-testid="reset-new-link">Get a new one</Link></p>
    </AuthShell>
  );
}
